var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSnap = function SvgIconSnap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_snap_svg__ikony",
    viewBox: "0 0 22 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_snap_svg__cls-1,.icon_snap_svg__cls-2{fill:#091f2c;stroke-width:0}.icon_snap_svg__cls-2{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 10v2.99c0 2.76-2.25 5.01-5.01 5.01s-5.01-2.25-5.01-5.01V10h-3v2.99C2.99 17.41 6.58 21 11 21s8.01-3.59 8.01-8.01V10zM2.99 1h1v1h-1zM18.01 1h1v1h-1zM6.75 3h1v1h-1zM14.26 3h1v1h-1zM10.51 1h1v1h-1zM16.01 7h3v2h-3zM2.99 7h3v2h-3z",
    className: "icon_snap_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    className: "icon_snap_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    className: "icon_snap_svg__cls-2"
  })));
};
export default SvgIconSnap;